<ag-grid-angular
  style="width: 1600px;"
  class="ag-theme-material"
  [rowData]="this.globals.allApplications ? allRowData : userRowData"
  [columnDefs]="columnDefs"
  [pagination]="true"
  [paginationPageSize]="paginationPageSize"
  domLayout="autoHeight"
  (gridReady)="onGridReady($event)"
  colResizeDefault='shift'
>
</ag-grid-angular>

<div class="page-size">
  Page Size:
  <select (change)="onPageSizeChanged()" id="page-size" title="pageSize">
    <option value="10" >10</option>
    <option value="20" selected>20</option>
    <option value="50">50</option>
    <option value="100">100</option>
  </select>
</div>
